module.exports = __webpack_public_path__ + "/build/web/svg/ic-plus-white.975b377406ec80c86cbe0764b56b5efc.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/ic-plus-white.svg
// module id = 97
// module chunks = 13